<template>
      <div id="Show">
        <div class="steps">
            <el-steps direction="vertical" :active="Active">
                <el-step v-for="(item, index) in listData" :key="index" :title="item.name"></el-step>
            </el-steps>
        </div>
        <div class="user">
            <div class="item" v-for="(item, index) in listData" :key="index">
                <button @click="onClk(subItm.id)" v-for="(subItm, index1) in item.stus" :key="index1">{{ subItm.name }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['listData'],
    name: 'mystep',
    data() {
        return {
            Active: 1,
            list: []
        }
    },
    methods: {
     
        onClk(id){
            console.log("点击了",id)
        },
        // 修改active
        show(active) {
            this.Active = active;
        },
        // 添加hover事件
        addEventListeners() {
            const text = document.getElementsByClassName("is-text");
            const title = document.getElementsByClassName("el-step__title");
            for (let i = 0; i < text.length; i++) {
                text[i].addEventListener("click", () => {
                    this.show(i + 1);
                });
                title[i].addEventListener("click", () => {
                    this.show(i + 1);
                });
                text[i].addEventListener("mouseenter", () => {
                    text[i].classList.add("hover");
                });
                title[i].addEventListener("mouseenter", () => {
                    title[i].classList.add("hover");
                });
            }
            this.height();
        },
        // 处理高度
        height() {
            const vertical = document.getElementsByClassName("is-vertical");
            const users = document.getElementsByClassName("item");
            console.log(users);
            for (let i = 0; i < this.listData.length; i++) {
                vertical[i].style.height = 10 * this.listData[i].day + "px";
                users[i].style.height = 10 * this.listData[i].day + "px";
            }
        }
    },
    mounted() {
        //this.setList();
        this.$nextTick(() => {
            this.addEventListeners();
        })
    },
}
</script>
<style>
#Show {
    width: 100%;
    height: 100%;
    display: flex;

    .steps {
        width: 100px;
    }

    .user {
        display: flex;
        flex-flow: column;
        height: auto;
        /* justify-content: space-between; */
        flex: 1;
    }

    .user div {
        display: flex;
        align-content: center;
        height: 100px;
    }

    .user div button {
        width: 45px;
        margin-right: 5px;
        height: 29px;
    }

    .hover {
        cursor: pointer;
    }

    .el-steps {
        display: block;
    }

    .el-steps--vertical {
        height: auto;

        .is-vertical {
            height: 100px;
        }
    }
}
</style>